<template>
  <div>
    <b-card header-class="h5 text-black mx-0" :no-body="!nodata">
      <template slot="header">
        <span class="icon icon-Reports text-primary" /> Graph
        <span v-b-toggle.graphCollapse class="float-right text-muted cursor-pointer">–</span>
      </template>
      <b-collapse :class="{ 'mt-3': !nodata }" id="graphCollapse" :visible="true">
          <template v-if="fields[0] === 'date'">
            <report-time-graph class="mx-0"
              v-if="fields.length === 1"
              :report="report"
              :stats="stats"
              :fields="fields"
              :interval="interval"
              :joint-tooltip="true"
              :timezone="timezone">
            </report-time-graph>
            <report-time-stat-graphs
              v-else
              :report="report"
              :stats="stats"
              :fields="fields"
              :interval="interval"
              :joint-tooltip="stats.length === 1"
              :timezone="timezone">
            </report-time-stat-graphs>
          </template>
          <div v-else-if="report.length > 1000">Report too large to be graphed</div>
          <template v-else>
            <report-bar-graphs
              :report="report"
              :stats="stats"
              :fields="fields"
              :timezone="timezone"
              :currently-viewed-report="currentlyViewedReport"
              @color-update="colorUpdate">
            </report-bar-graphs>
          </template>
      </b-collapse>
    </b-card>
  </div>
</template>


<script>
  import ReportTimeGraph from '@/reports/components/graphs/ReportTimeGraph'
  import ReportTimeStatGraphs from '@/reports/components/graphs/ReportTimeStatGraphs'
  import ReportBarGraphs from '@/reports/components/graphs/ReportBarGraphs'


  export default {
    methods: {
      colorUpdate(colors) {
        this.$emit('color-update', colors)
      }
    },
    props: {
      report: { required: true, type: Array },
      stats: { required: true, type: Array },
      fields: { required: true, type: Array },
      timezone: { required: false, type: String },
      nodata: { required: true, type: Boolean },
      interval: { required: false, type: String },
      currentlyViewedReport: { type: Array, required: true }
    },
    components: {
      ReportTimeGraph,
      ReportTimeStatGraphs,
      ReportBarGraphs
    }
  }
</script>



// WEBPACK FOOTER //
// src/reports/pages/Explorer/ReportGraphs.vue